<div class="container-fluid banner-fundo">
    <img id="u81_img" class="img " src="../../../assets/images/ordem/u80.png" alt="Banner Fundo">
    <img id="u80_img" class="img " src="../../../assets/images/ordem/u81.png" alt="Banner Fundo">
  <div class="container slide">
    <div class="row">
      <div class="col-3 botao-cadastro text-center">
        <button
          class="btn-azul"
          mat-raised-button
          routerLink="/cadastrar-ordem"
          [attr.data-cy]="'button-cadastrar-ordem'"
        >
          <mat-icon>add_circle</mat-icon>
          Cadastrar Ordem
        </button>
      </div>
      <div class="col-1 align-content-center text-center">
        <img id="u90_img" class="img " src="../../../assets/images/ordem/u90.png" alt="Ícone de divisória">
      </div>
      <div class="col-3 busca-conteudo align-content-center">
        <a routerLink="/listar-ordem" [attr.data-cy]="'link-listar-ordem'">
          <h5>
            <img id="u96_img" class="shadow" src="../../../assets/images/ordem/u96.png" alt="Ícone de listagem">
            Ordens Cadastradas
          </h5>
        </a>
      </div>
      <form [formGroup]="form" class="col-5 text-left align-content-center busca-conteudo">
        <h2 class="label-busca"> Buscar Ordens</h2>
        <div class="buscar-container">
          <mat-form-field appearance="outline" class="md-button-right itens-centro">
              <mat-label>Preencher Número do Processo padrão CNJ</mat-label>
              <input
                maxlength="25"
                matInput
                mask="0000000-00.0000.0.00.0000"
                placeholder="0000000-00.0000.0.00.0000"
                formControlName="nroProcesso"
                [attr.data-cy]="'input-numero-processo'"
              />
              <button
                matSuffix
                class="float-right mx-2"
                (click)="buscarPorNroProcesso(form.value)"
                [disabled] ="nroProcesso.value.length < 20"
                mat-raised-button
                [attr.data-cy]="'button-buscar-ordem'"
                > Buscar </button>
              <mat-hint align="end">{{nroProcesso.value.length}} / 20</mat-hint>
              <mat-error *ngIf="nroProcesso.hasError('required')">
                  Numero CNJ é <strong>obrigat&oacute;rio</strong>
                </mat-error>
                <mat-error *ngIf="nroProcesso.hasError('minlength')">
                  N&uacute;umero CNJ deve possuir  20 caracteres. Atual
                  {{nroProcesso.value.length}} / 20.
                </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</div>


